var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAppleBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.7332 27.04C21.4266 28.3067 19.9999 28.1067 18.6266 27.5067C17.1732 26.8933 15.8399 26.8667 14.3066 27.5067C12.3866 28.3333 11.3732 28.0933 10.2266 27.04C3.71989 20.3333 4.67989 10.12 12.0666 9.74667C13.8666 9.84 15.1199 10.7333 16.1732 10.8133C17.7466 10.4933 19.2532 9.57333 20.9332 9.69333C22.9466 9.85333 24.4666 10.6533 25.4666 12.0933C21.3066 14.5867 22.2932 20.0667 26.1066 21.6C25.3466 23.6 24.3599 25.5867 22.7199 27.0533L22.7332 27.04ZM16.0399 9.66667C15.8399 6.69333 18.2532 4.24 21.0266 4C21.4132 7.44 17.9066 10 16.0399 9.66667Z",
    fill: "#151515"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppleBlack);
export default __webpack_public_path__ + "static/media/AppleBlack.6ca9e00359680831e260f6b84859e4f3.svg";
export { ForwardRef as ReactComponent };